const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const PAD_LENGTH = 2;

const pad = (value: number) => value.toString().padStart(PAD_LENGTH, '0');

/** `mm:ss`, or `h:mm:ss` once the call runs over an hour. */
export const formatCallDuration = (totalSeconds: number) => {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safeSeconds / (SECONDS_PER_MINUTE * MINUTES_PER_HOUR));
  const minutes = Math.floor(safeSeconds / SECONDS_PER_MINUTE) % MINUTES_PER_HOUR;
  const seconds = safeSeconds % SECONDS_PER_MINUTE;

  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`;
};
